import React from 'react';
import styled, { css } from 'styled-components';

import Container from 'partials/Container';
import Html from 'partials/Html';
import AnimateIn from 'partials/AnimateIn';
import Widgets from './Widgets';
import ImageWidget from './ImageWidget';
import { isMobile } from 'helpers';

export default props => {
    const { content, show_sidebar, widgets } = props.data;
    const pageBackground = props.page && props.page.acf && props.page.acf.page_background ? props.page.acf.page_background : 'white';
    //console.log('Rich text:',props.data);

    const flatMap = (array, fn) => {
        var result = [];
        for (var i = 0; i < array.length; i++) {
            var mapping = fn(array[i]);
            result = result.concat(mapping);
        }
        return result;
    }

    /**
     * Search for image within widgets and take the first result. 
     * Look for [mobile-picture] tag within the RichText, and replace it 
     * with a ImageWdget if the screen is mobile sized. Otherwise remove the tag.
     */
    const contentToJSXComponent = (string, widgets, isMobile) => {
        var result = '';
        let image = null;
        result = flatMap(string.split('[mobile-picture]'), function (part) {
            if(widgets.length > 0) image = widgets.filter(widget => widget.image).shift();
            if(!isMobile) return string.replace('[mobile-picture]', '');
            return image ? [part, <ImageWidget data={image.image}  />] : null;
        });
        if(contentContainsMobileShortcut(string))
        {
            result.pop();
            return result;
        }
        return result;
    }

    /**
     * If the array of content objects contains any react object, then display it without HTML component wrapper
     */
    const applyMobileShortcodes = (content, widgets, isMobile) => {
        return(
            contentToJSXComponent(content, widgets, isMobile).map((element) => {
                if(element)
                {
                    { return React.isValidElement(element) ? element: <Html content className="html-content">{element}</Html> }
                } else {
                    { return React.isValidElement(element) ? element: <Html content className="html-content">{content}</Html> }
                }
                
            })
        )
    }

    const contentContainsMobileShortcut = () => {
        return content.includes('[mobile-picture]');
    }
   
    return (
        <ModuleWrapper>
            <AnimateIn>
                <Container small={!show_sidebar} flex wrap >

                    {show_sidebar &&
                        <Sidebar className={contentContainsMobileShortcut && isMobile() ? 'noImage' : ''}>
                            <Widgets widgets={widgets} page={props.page} />
                        </Sidebar>
                    }

                    <Main sidebar={show_sidebar} pageBackground={pageBackground}>
                        {  applyMobileShortcodes(content, widgets, isMobile()) }
                    </Main>
                </Container>
            </AnimateIn>
        </ModuleWrapper>
    );
}

const ModuleWrapper = styled.article`
    margin-bottom:60px;
    @media (max-width: 768px) {
        margin-bottom:40px;
    }
`

const Main = styled.div`
    width:100%;
    
    ${props => props.pageBackground === 'main' ? `
        .html-content * {
            color: white;
        }
    ` : ``}

    ${props => props.sidebar ? `
        width: 60%; 
        padding-left: 20px;
        @media(max-width: 767px) {
            width:100%;
            padding-left: 0;
            display: flex;
            flex-direction: column; 
            flex-wrap: wrap;
            order: 1;
        }
    ` : ``}
`

const Sidebar = styled.div`
    width:40%;
    padding-right:20px;
    @media(max-width: 767px) {
        width:100%;
        padding-right: 0;
        display: flex;
        order: 2;
    }
    
    &.noImage {
       img {
           display: none;
       }
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/RichText/RichText.js